export const RandomProjectHotkey = () =>
  window.addEventListener('keydown', (event) => {
    if (event.ctrlKey && event.altKey && event.keyCode == 80) { // ctrl+alt+p
      event.preventDefault()
      window.location.href = '/projects/random'
    }
  })
